export default class Noder {
  computeNodes(segStrings) {}
  getNodedSubstrings() {}
}
